export const sendComscoreBeacon = (customParams = {}) => {
  if (typeof window !== 'undefined' && window.COMSCORE) {
    const defaultParams = {
      c1: '2',
      c2: '28893285',
      c7: window.location.href,
      c8: document.title,
    };

    window.COMSCORE.beacon({
      ...defaultParams,
      ...customParams,
    });
  }
};
